var settings = {};
var changes = false;

const otherMaterials = [
  "azure-dust",
  "charcoal-dust",
  "pewter-dust",
  "sage-no-chip",
];

var material = "bianco-london-plane",
  edge = "square",
  thickness = "24mm",
  splashback = "no-splashback",
  splashbackHeight = 0,
  shape = "rectangular",
  shapeWallType = "no-walls",
  islandPrice = 0,
  islandPriceExclVAT = 0,
  accessories = "maintenance-kit";

const onScroll = (event) => {
  var scrollPos = $(document).scrollTop();
  $("#worktop_tabs ul.tabs-nav a").each(function () {
    var currLink = $(this);
    var refElement = $(currLink.attr("href"));
    if (
      refElement.position().top - 48 <= scrollPos &&
      refElement.position().top + refElement.height() - 48 > scrollPos
    ) {
      $("#worktop_tabs ul li").removeClass("state-active");
      currLink.parent().addClass("state-active");
    } else {
      currLink.parent().removeClass("state-active");
    }
  });
};

$(function () {
  $(document).on("scroll", onScroll);

  $(
    '#worktop_tabs ul.tabs-nav a[href^="#"], .worktop_sidebar .btn_groups a[href^="#"]'
  ).on("click", function (e) {
    e.preventDefault();
    $(document).off("scroll");

    $("a").each(function () {
      $(this).parent().removeClass("state-active");
    });
    $(this).parent().addClass("state-active");
    
    var isActionClicked =
        $(this).hasClass("save-btn") || $(this).hasClass("order-btn"),
      $lastTab = $("#worktop_tabs .tabs-panel:last-of-type");
    if (isActionClicked) {
      $lastTab.removeClass("hidden");

      if ($(this).hasClass("order-btn")) {
        $lastTab.find("#order-actions").removeClass("display-none");
        $lastTab.find("#save-actions").addClass("display-none");
      } else {
        $lastTab.find("#order-actions").addClass("display-none");
        $lastTab.find("#save-actions").removeClass("display-none");
      }
    }

    var target = this.hash,
      menu = target;
    var $target = $(target);
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.position().top - 45,
        },
        100,
        "swing",
        function () {
          $(document).on("scroll", onScroll);

          if (!isActionClicked) {
            $lastTab.addClass("hidden");
          }
        }
      );
  });

  $(".worktop_select .theme-card-wrap input[type=text]").bind(
    "keyup paste",
    function () {
      this.value = this.value.replace(/[^0-9]/g, "");
    }
  );

  $(document).on(
    "change keyup",
    ".worktop_select_plan input[type=text]",
    function () {
      validateDimensions($(this));
    }
  );

  $(document).on(
    "change keyup",
    ".worktop_select .island-wrap input[type=text]",
    function () {
      validateIslandDimensions($(this));
    }
  );
});

$(document).ready(function () {
  $('input[name="edgeType"]').attr("disabled", true);
  $('input[name="thicknessType"]').attr("disabled", true);
  $('input[name="splashbackType"]').attr("disabled", true);
  $("#tabs-2 .worktop_select .theme-card-wrap input[type=text]").attr(
    "disabled",
    true
  );
  $("input.ShapeWallType").attr("disabled", true);

  $('input[name="islandType"]')
    .parents("div.plan_tab_main")
    .nextAll("p, div")
    .hide();
  $('input[name="island[wall]"]').attr("disabled", true);
  $(".island_plus_icon_svg").attr("disabled", true);
  $(".island_cutouts").addClass("isDisabled");

  // Style ==> Material
  $(document).on("change", 'input[name="materialType"]', function () {
    material = $(this).val();
    materialCalculation();

    var materialColour = $('input[name="materialType"]:checked')
      .parent()
      .find(".small_title")
      .text();
    var materialWood = $('input[name="materialType"]:checked')
      .parent()
      .find(".sub_title")
      .text();
    $(".material_name").html(materialColour + " / " + materialWood);

    // changing images of Style tabs
    $(".worktop_select").removeClass("blured_img");

    var materialImage = $('input[name="materialType"]:checked')
      .parent()
      .find("img")
      .attr("alt");

    $("#tabs-1 img.edge-image[alt=square]").attr(
      "src",
      settings["material"][material]["square_edge_image"]
    );
    $("#tabs-1 img.edge-image[alt=cutaway]").attr(
      "src",
      settings["material"][material]["cutaway_edge_image"]
    );

    $("#tabs-1")
      .find("img.thickness-image[alt=20mm], img.thickness-image[alt=24mm]")
      .attr("src", settings["material"][material]["24mm_thickness_image"]);
    $("#tabs-1")
      .find("img.thickness-image[alt=32mm], img.thickness-image[alt=36mm]")
      .attr("src", settings["material"][material]["36mm_thickness_image"]);

    if (otherMaterials.indexOf(material) !== -1) {
      $("#tabs-1 .select_card_design.worktop_select.thickness")
        .find("label.20mm, label.32mm")
        .show();
      $("#tabs-1 .select_card_design.worktop_select.thickness")
        .find("label.24mm, label.36mm")
        .hide();
      if ($.inArray(thickness, ["24mm", "36mm"]) !== -1)
        $("input:radio[name=thicknessType][value='20mm']")
          .prop("checked", true)
          .change();
    } else {
      $("#tabs-1 .select_card_design.worktop_select.thickness")
        .find("label.20mm, label.32mm")
        .hide();
      $("#tabs-1 .select_card_design.worktop_select.thickness")
        .find("label.24mm, label.36mm")
        .show();
      if ($.inArray(thickness, ["20mm", "32mm"]) !== -1)
        $("input:radio[name=thicknessType][value='24mm']")
          .prop("checked", true)
          .change();
    }

    $('input[name="edgeType"]').attr("disabled", false);
    $('input[name="thicknessType"]').attr("disabled", false);
    $('input[name="splashbackType"]').attr("disabled", false);
  });
  // Style ==> Edge
  $(document).on("change", 'input[name="edgeType"]', function () {
    edge = $(this).val();
    const shapeFormula = parseFormula("edge", shape, true);
    if (shapeFormula) {
      const totalPriceFormula = shapeFormula.totalFormula.replace(
        "|EDGE|",
        settings["edge"][edge]["price"]
      );
      const totalPrice = eval(totalPriceFormula);

      const exclVatPriceFormula = shapeFormula.exclVatFormula.replace(
        "|EDGE|",
        settings["edge"][edge]["excl_vat"]
      );
      const exclVatPrice = eval(exclVatPriceFormula);

      renderPrice(totalPrice, exclVatPrice, ".edge_amount");
    }
    islandCalculation();
    var EdgeName = $('input[name="edgeType"]:checked')
      .parent()
      .find(".small_title")
      .text();
    $(".edge_name").html(EdgeName);
  });
  // Style ==> Thickness
  $(document).on("change", 'input[name="thicknessType"]', function () {
    thickness = $(this).val();

    materialCalculation();

    islandCalculation();
  });
  // Style ==> Splashback
  $(document).on("change", 'input[name="splashbackType"]', function () {
    splashbackCalculation();
  });
  // Style ==> Splashback Height
  $('input[name="splashbackHeight"]').on("change keyup", function () {
    splashbackHeight = $(this).val();
    console.log(splashbackHeight);

    splashbackCalculation();
  });

  // Plan ==> Wall Locations
  $(document).on("change", "input.ShapeWallType", function () {
    onSelectWallType($(this));
  });
  // Plan ==> Shape
  $(document).on("change", 'input[name="shapeType"]', function () {
    shape = $(this).val();

    $("#tabs-2 .worktop_select .theme-card-wrap input[type=text]").attr(
      "disabled",
      true
    );
    $(this)
      .parents(".theme-card-wrap")
      .find("input[type=text]")
      .attr("disabled", false);

    $(".plan-walls > .select_card_design")
      .addClass("display-none")
      .removeClass("display-flex");
    $(".plan-walls > .select_card_design.plan_wall_" + shape)
      .addClass("display-flex")
      .removeClass("display-none");

    const shapeFormula = parseFormula("shape", shape, true);
    if (shapeFormula) {
      const priceExclVAT = eval(shapeFormula.exclVatFormula);
      const totalPrice = eval(shapeFormula.totalFormula);

      renderPrice(totalPrice, priceExclVAT);

      $("input:radio[name=materialType][value='" + material + "']")
        .prop("checked", true)
        .change();
      $("input:radio[name=edgeType][value='" + edge + "']")
        .prop("checked", true)
        .change();
      $("input:radio[name=thicknessType][value='" + thickness + "']")
        .prop("checked", true)
        .change();

      var wallElm = $(
        "input:radio[name='shape[" +
          shape +
          "][wall]'][value='" +
          shape +
          "_no-walls']"
      );
      wallElm.prop("checked", true).change();
      onSelectWallType(wallElm);

      splashbackCalculation();
    }

    onShapeSelection();
  });

  // Cut Outs ==> Plus
  $(".plus_icon_svg").on("click", function () {
    var $qty = $(this).parents(".cut_outs_card").find(".cutouts_plus_minus");
    var currentVal = parseInt($qty.val());
    var newVal;

    if (!isNaN(currentVal)) {
      newVal = currentVal + 1;
      $qty.val(newVal);
    } else {
      newVal = 0;
    }

    if (newVal < 1) {
      $(this).parent().find(".minus_icon_svg").addClass("disabled");
    } else {
      $(this).parent().find(".minus_icon_svg").removeClass("disabled");
    }

    cutoutCalculation();
  });
  // Cut Outs ==> Minus
  $(".minus_icon_svg").on("click", function () {
    var $qty = $(this).parents(".cut_outs_card").find(".cutouts_plus_minus");
    var currentVal = parseInt($qty.val());
    var newVal;

    if (!isNaN(currentVal) && currentVal > 0) {
      newVal = currentVal - 1;
      $qty.val(newVal);
    } else {
      newVal = 0;
    }

    if (newVal <= 0) {
      $(this).addClass("disabled");
    } else {
      $(this).removeClass("disabled");
    }

    cutoutCalculation();
  });

  // Island ==> Wall Locations
  $(document).on("change", 'input[name="island[wall]"]', function () {
    islandCalculation();
  });
  // Island ==> Selection
  $(document).on("change", 'input[name="islandType"]', function () {
    var islandType = $('input[name="islandType"]:checked').val();

    if (islandType == "no-island") {
      $(".worktop_select .island-wrap input[type=text]").attr("disabled", true);

      $('input:radio[name="island[wall]"]').prop("checked", false).change();
      $('input:radio[name="island[wall]"]').attr("disabled", true);

      $(".island_plus_icon_svg").attr("disabled", true);
      $(".island_minus_icon_svg").attr("disabled", true);
      $(".island_minus_icon_svg").addClass("disabled");

      $('input[name="islandTapCutOut"]').val(0);
      $('input[name="islandSinkCutOut"]').val(0);
      $('input[name="islandHobCutOut"]').val(0);

      islandCutoutCalculation();

      $(".island_cutouts").addClass("isDisabled");
      $(".island_section").addClass("d-none");

      $('input[name="islandType"]')
        .parents("div.plan_tab_main")
        .nextAll("p, div")
        .hide();
    } else {
      $(".worktop_select .island-wrap input[type=text]").attr(
        "disabled",
        false
      );

      $('input:radio[name="island[wall]"][value="no-walls"]')
        .prop("checked", true)
        .change();
      $('input:radio[name="island[wall]"]').attr("disabled", false);

      $(".island_plus_icon_svg").attr("disabled", false);
      $(".island_minus_icon_svg").attr("disabled", false);

      $(".island_cutouts").removeClass("isDisabled");
      $(".islandpselect").removeClass("d-none");
      $(".island_section").removeClass("d-none");

      $('input[name="islandType"]')
        .parents("div.plan_tab_main")
        .nextAll("p, div")
        .show();
    }

    islandCalculation();
  });
  // Island ==> Cut Outs Plus
  $(".island_plus_icon_svg").on("click", function () {
    var $qty = $(this)
      .parents(".cut_outs_card")
      .find(".island_cutouts_plus_minus");
    var currentVal = parseInt($qty.val());
    var newVal;

    if (!isNaN(currentVal)) {
      newVal = currentVal + 1;
      $qty.val(newVal);
    } else {
      newVal = 0;
    }

    if (newVal < 1) {
      $(this).parent().find(".island_minus_icon_svg").addClass("disabled");
    } else {
      $(this).parent().find(".island_minus_icon_svg").removeClass("disabled");
    }

    islandCutoutCalculation();
  });
  // Island ==> Cut Outs Minus
  $(".island_minus_icon_svg").on("click", function () {
    var $qty = $(this)
      .parents(".cut_outs_card")
      .find(".island_cutouts_plus_minus");
    var currentVal = parseInt($qty.val());
    var newVal;

    if (!isNaN(currentVal) && currentVal > 0) {
      newVal = currentVal - 1;
      $qty.val(newVal);
    } else {
      newVal = 0;
    }

    if (newVal <= 0) {
      $(this).parent().find(".island_minus_icon_svg").addClass("disabled");
    } else {
      $(this).parent().find(".island_minus_icon_svg").removeClass("disabled");
    }

    islandCutoutCalculation();
  });

  // Style ==> Accessories
  $(document).on("change", 'input[name="accessoriesType"]', function () {
    accessories = $(this).val();
    AccessoriesCalculation();

    if (accessories != "no-accessoriesType") {
      var accessories_item = $('input[name="accessoriesType"]:checked')
        .parent()
        .find(".small_title")
        .text();
      $(".accessories_name").html(accessories_item);
    }
  });

  // Request Invoice
  $("#requestInvoiceButton").on("click", function (event) {
    event.preventDefault();

    submitQuote("Request Invoice", 1);
  });

  // Email Me
  $("#emailMeButton").on("click", function (event) {
    event.preventDefault();

    submitQuote("Email Me", 5);
  });

  // Save to account
  $("#saveToAccountButton").on("click", function (event) {
    event.preventDefault();

    saveOrBuy(4);
  });

  // Add to cart
  $("#buyNowButton").on("click", function (event) {
    event.preventDefault();

    $("#worktop_loader").css({ opacity: 0.8, display: "flex" });

    $.getJSON("/cart.js", function (cart) {
      if (cart.item_count > 0) {
        var worktopAddedtoCart = 0;
        $.each(cart.items, function (i, item) {});
      }

      saveOrBuy(6);
    });
  });

  // Start Over
  $("#startOverButton").on("click", function () {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "startOver_confirm",
      },
      showClass: {
        popup: "",
      },
    });

    swalWithBootstrapButtons
      .fire({
        title: "Start over",
        icon: "question",
        html: "Are you sure?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        focusConfirm: false,
      })
      .then((result) => {
        if (result.isConfirmed) {
          setDefaultData();

          $('input[name="splashbackType"][value="no-splashback"]')
            .prop("checked", true)
            .change();

          $('input[name="island[wall]"]').attr("disabled", true);
          $(".island_plus_icon_svg").attr("disabled", true);

          $('input[name="islandType"][value="no-island"]')
            .prop("checked", true)
            .change();
          $(".island_cutouts").addClass("isDisabled");

          $(".minus_icon_svg, .island_minus_icon_svg").addClass("disabled");

          $(
            ".tap, .sink, .hob, .2sided, .3sided, .islandtap, .islandsink, .islandhob"
          ).addClass("d-none");

          $(".subtitle_reset").removeClass("d-none");

          // reset cutout cards
          $(".cutouts_plus_minus, .island_cutouts_plus_minus").each(
            function () {
              $(this).val(0);
            }
          );
          cutoutCalculation();
          islandCutoutCalculation();

          $(".cut_outs_card")
            .find(".amount_value")
            .each(function () {
              $(this).text(0);
            });

          // activating style tab
          $(function () {
            // $( "#worktop_tabs" ).tabs({
            //   active: 0,
            //   cache:true,
            // });
          });
        }
      });
  });

  getPriceSettings();
});

window.onbeforeunload = function () {
  if (changes) {
    var message =
      "If you leave now, none of this will be saved!\n\nIt only takes a moment to save your changes. And you don’t even need to register. Choose the “save” option. You can continue progress using the code you receive when you click save.";
    return message;
  } else {
    return;
  }
};
